import {connect} from 'react-redux'
import MeineAusbildung from './index'

const mapStateToProps = state => ({
  userId: state.authentication.id,
})

export default connect(mapStateToProps)(MeineAusbildung)
